export default __webpack_public_path__ + "static/media/pic-portfolio.4fc26a9a.jpg";